// src/components/copilot/ChatWelcome.jsx
import { Box, Chip, Paper, Typography } from "@mui/material";
import { memo, useMemo } from "react";
import Txt from "../../../typography/Txt";

const ChatWelcome = memo(({ profileContext, onSendMessage }) => {
  const suggestions = useMemo(() => {
    const items = [];
    if (!profileContext.hasEntities) {
      items.push("Help me add a business entity");
    }
    if (!profileContext.hasExperience) {
      items.push("How do I add investment experience?");
    }
    if (!profileContext.hasDocuments) {
      items.push("What documents do I need to upload?");
    }
    if (profileContext.loansWithConditions > 0) {
      items.push("Show me loans that need attention");
    }
    items.push("What's missing from my profile?");
    return items.slice(0, 4);
  }, [profileContext]);

  return (
    <>
      <Paper
        sx={{
          p: 2.5,
          bgcolor: "white",
          borderLeft: 4,
          borderColor: "primary.main",
        }}
      >
        <Typography variant="body1" gutterBottom>
          👋 Hi! I'm your Loan Assistant.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          I can help you complete your profile and manage your loan
          applications.
        </Typography>
      </Paper>

      {suggestions.length > 0 && (
        <Box>
          <Txt secondary variant="caption" sx={{ mb: 1, display: "block" }}>
            Quick actions:
          </Txt>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {suggestions.map((suggestion, i) => (
              <Chip
                key={i}
                label={suggestion}
                onClick={() => onSendMessage(suggestion)}
                variant="outlined"
                size="small"
                sx={{ cursor: "pointer" }}
              />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
});

ChatWelcome.displayName = "ChatWelcome";

export default ChatWelcome;
